<template>
    <div class="leftO">
        <div class="leaderBox" v-if="showOrhide">
            <div class="newtext">新手指引</div>
            <img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../assets/images/pop/dbzx/dbzx.jpg" class="steps step1" v-if="status==1">
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
<!--        <breadcrumb :routerList="[{title:'待办中心'}]"/>-->
      <Breadtabsheader/>
        <!-- <div class="title2">
            订单审批事项待办详情
        </div> -->
        <div style="margin: 0.22rem 0.38rem 0 0.32rem;background:#fff;padding: 0.4rem 0.4rem 0.4rem 0.4rem;">
            <div style="position:relative;">
                <div class="buttonBox" style="margin-top: 0.1rem;">
                    <div class="buttons" :class="{'active':indx == index}" v-for="(item,index) in options" :key="index"
                         @click="changes(index,item.value)">{{item.label}}
                    </div>
                </div>
                <el-form :inline="true" class="demo-form-inline h-formBorder"
                         style="position: absolute;right:0;bottom: 0;display: flex;align-items: center;">
					<el-form-item label="备注" prop="usercode">
						<el-input clearable v-model="query.beizhuLike" style="width:1.5rem;"></el-input>
					</el-form-item>
                    <el-form-item label="提交人" prop="usercode">
                        <el-input clearable v-model="query.dbcjrnameLike" style="width:1.5rem;"></el-input>
                    </el-form-item>
                    <el-form-item label="审批流分类" prop="usercode">
                        <el-select v-model="value"
                                   placeholder="请选择"
                                   filterable
                                   clearable
                                   @change="changedaiban"
								   style="width: 2rem;"
                        >
                            <el-option
                                    v-for="(item) in options1"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code">
                            </el-option>
                        </el-select>

                    </el-form-item>

                    <el-form-item label="使用人" prop="userName" v-if="this.query.progresstype==2">
                        <el-input clearable v-model="query.userName" style="width:2rem;"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button class="h-btn h-formBtn" @click="dbhandleFilter">检索</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="shenpi">
                <div class="s-row" v-for="(o,i) in tableData" :key="i">
                    <span class="type type-pt" :title="o.progressName">{{o.progressName}}</span>
                    <span class="name" style="width: 1.5rem" :title="o.cjrname">{{o.cjrname}}</span>
                    <span class="content-xin">
						<span class="resolve overflowT" style="width: 1.5rem; display:inline-block;padding-right:0" :title="o.name">{{o.name}}</span>
						<span class="time overflowT" style="width: 0.8rem;display:inline-block;padding-right:0" :title="o.begindateStr">{{o.begindateStr}}</span>
                        <span class="resolve overflowT" v-if="o.progresstype!=2" style="margin-left: 5%;width: 6rem;display:inline-block;" :title="o.beizhu">{{o.beizhu}}</span>
                        <span class="resolve overflowT" v-if="o.progresstype==2" style="margin-left: 5%;width: 5rem;display:inline-block;" :title="o.beizhu">{{o.beizhu}}</span>
                        <span class="name" style="width: 2rem" v-if="o.progresstype==2" :title="o.userName">{{o.userName}}</span>

					</span>

<!--					<el-button class="submit submit-tj"-->
<!--							   style="margin-right: 10%"-->
<!--							   @click="saveBeiZhu(o)"-->
<!--					>保存备注-->
<!--					</el-button>-->
					<!-- <div class="l-operationBox" style="width: auto;">
						<span class="l-operationlist br-operation-qcl" v-if="o.status==0" title="去处理" @click="toShowOrComplate(o)"></span>
						<span class="l-operationlist br-operation-look" v-else title="查看" @click="toShowOrComplate(o)"></span>
						<span class="l-operationlist br-operation-spgz" style="margin-left: 0.1rem;" title="流程跟踪" @click="genzongLiuch(o)"></span>
					</div> -->
					<el-button class="submit"
					           :class="o.status==0?'submit-tj':'submit-wc'"
					           @click="toShowOrComplate(o)"
							   style="padding: 0.05rem 0.1rem;"
					>{{o.status==0?'去处理':'查看'}}
					</el-button>
                    <el-button class="submit submit-tj"
                               @click="genzongLiuch(o)"
							   style="padding: 0.05rem 0.1rem;"
                    >流程跟踪
                    </el-button>

                    <!-- <el-button class="submit submit-tj"
                               @click="deleteTask(o)"
                               v-if="o.status==0"
							   style="color: rgba(256,0,0,0.5);border-color: rgba(256,0,0,0.5);"
                    >删除代办
                    </el-button> -->
                </div>
            </div>
            <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                <pagination :page="query" @query="search"/>
            </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>

        <el-dialog :visible.sync="order.showOrderNxSp"
                   v-if="order.showOrderNxSp"
                   v-on="$listeners"
                   :modal-append-to-body='false'
				    :close-on-click-modal="false"
                   append-to-body
                   :title="order.nwsale ?'外销订单' : '内销订单'"
                   width="90%" class="showflowDialogcls">
            <ordernxsp
                       :orderid="order.orderid"
                       :orderinstid="order.orderinstid"
                       :ordertaskid="order.ordertaskid"
                       :ordertaskstatus="order.ordertaskstatus"
                    @refreshSelf="refreshSelf"
            />
        </el-dialog>
        <el-dialog :visible.sync="order.showOrderNxSp1N"
                   v-if="order.showOrderNxSp1N"
                   v-on="$listeners"
                   :modal-append-to-body='false'
                   :close-on-click-modal="false"
                   append-to-body
                   :title="order.nwsale ?'外销订单' : '内销订单'"
                   width="90%" class="showflowDialogcls">
            <ordernxsp1N
                :orderid="order.orderid"
                :orderinstid="order.orderinstid"
                :ordertaskid="order.ordertaskid"
                :ordertaskstatus="order.ordertaskstatus"
                @refreshSelf="refreshSelf"
            />
        </el-dialog>
        <orderwxsp
                :visible.sync="order.showOrderWxSp"
                v-if="order.showOrderWxSp"
                :orderid="order.orderid"
                :orderinstid="order.orderinstid"
                :ordertaskid="order.ordertaskid"
                :ordertaskstatus="order.ordertaskstatus"
                @refreshSelf="refreshSelf"
        />
        <el-dialog :visible.sync="order.slShowOrderNxSp"
                   v-if="order.slShowOrderNxSp"
                   v-on="$listeners"
                   :modal-append-to-body='false'
                   :close-on-click-modal="false"
                   append-to-body
                   title="分销商订单"
                   width="90%" class="showflowDialogcls">
            <secondOrdernxsp
                    :orderid="order.orderid"
                    :orderinstid="order.orderinstid"
                    :ordertaskid="order.ordertaskid"
                    :ordertaskstatus="order.ordertaskstatus"
                    @refreshSelf="refreshSelf"
            />
        </el-dialog>
        <el-dialog :visible.sync="order.slShowFjNxSp"
                   v-if="order.slShowFjNxSp"
                   v-on="$listeners"
                   :modal-append-to-body='false'
                   :close-on-click-modal="false"
                   append-to-body
                   title="分销商附件"
                   width="90%" class="showflowDialogcls">
            <secondFjnxsp
                    :orderid="order.orderid"
                    :orderinstid="order.orderinstid"
                    :ordertaskid="order.ordertaskid"
                    :ordertaskstatus="order.ordertaskstatus"
                    @refreshSelf="refreshSelf"
            />
        </el-dialog>

    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    export default {
        data() {
            return {
                showhistory: false,
                instid: null,
                showOrhide: false,
                status: 1,
                checked: true,
                toshow: "dealCenter2",
                options1: [],
                value: '',
                indx: 0,
                activeCode: '',
                query: {
                    status: null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    progresstype: null,
                    dbcjrnameLike: null,
					beizhuLike: null,
                    userName: null,
                },
                order:{
                    showOrderNxSp:false,
                    showOrderNxSp1N:false,
                    showOrderWxSp:false,
                    slShowOrderNxSp:false, //分销商订单
                    slShowFjNxSp:false, //分销商订单
                    orderid:"",
                    orderinstid:"",
                    ordertaskid:"",
                    ordertaskstatus:"",
                    nwsale:false,
                },
                tablist: [],
                tableData: [],
                taskstatus: null,
                options: [{
                    value: '0',
                    label: '未处理'
                }, {
                    value: '1',
                    label: '已处理'
                }, {
                    value: '',
                    label: '全部'
                }],
            };
        },
        mounted() {

            this.dbhandleFilter();

        },
       watch: {
  '$route.path': function (newVal, oldVal) {
      this.dbhandleFilter()

  }
       },

        created() {
            this.showzhezhao()
            this.query.status = 0
            this.search(status);
            this.options1 = this.$store.getters.dictlist("progress_type")
            console.log(this.options1)
        },
      beforeRouteLeave(to, from, next) {
        localStorage.removeItem("isNOCache");
        next();
      },
      beforeRouteEnter(to, from, next) {
        if (localStorage.getItem("isNOCache")) {
          to.meta.keepAlive = false;
        } else {
          to.meta.keepAlive = true;
        }
        next();
      },
      methods: {
            refreshSelf(params){
                if(params && params.close){
                    this.order.showOrderNxSp = false;
                    this.order.slShowOrderNxSp = false;
                    this.order.slShowFjNxSp = false;
                    this.order.showOrderNxSp1N = false;
                }
                if(params && params.refresh){
                    this.dbhandleFilter();
                }
            },
            deleteTask(v) {
                this.$msg.confirm("代办删除后可能会对整体流程产生极大影响, 确认删除？", () => {
                    ss.taskservice.deleteTask(v.id).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.search();
                    })
                })
            },
			saveBeiZhu(v){
				ss.taskservice.savebeizhu(v).then(res => {
					if (res.f){
						this.$message({
							message: '保存成功',
							type: 'success'
						});
					}
				})
			},
            showzhezhao() {
                ss.salesList.toshow(this.toshow).then(rd => {
                    if (rd == false) {
                        this.showOrhide = false;
                    } else {
                        this.showOrhide = true;
                    }
                })
            },
            genzongLiuch(r) {
                console.log(r)
                // if (r.orderCategory == '1' || r.orderCategory == '3') {
                //     this.instid = r.binstid;
                // } else {

                // }
                this.instid = r.instid;
                this.showhistory = true;
            },
            changedaiban(type) {
                console.log(type)
                this.activeCode = type
                this.query.progresstype = type
                this.query.userName = ""
                this.search(type)
            },
            changeOption(i) {
                this.query.status = i;
                this.search();
            },
            handleCurrentChange(i) {
                this.query.pageNo = i;
                this.search();
            },
            search() {
                ss.taskservice.query(this.query).then(rd => {
                    this.query.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            toShowOrComplate(r) {
                if(r.progresstype == '3' && _.includes(r.dburl, "orderNxshenpi1+N")){
                    if (undefined !=r.beizhu && '' != r.beizhu &&  null != r.beizhu  && r.beizhu.indexOf('外销订单-租赁订单') != -1){
                        this.order.nwsale = true;
                    }else {
                        this.order.nwsale = false;
                    }
                    this.order.orderid=r.ywid;
                    this.order.orderinstid=r.instid;
                    this.order.ordertaskid=r.id;
                    this.order.ordertaskstatus=r.status;
                    this.order.showOrderNxSp1N = true;
                    return;
                }
                console.log(r.progresstype == '3');
                console.log(_.includes(r.dburl,"dingdmain/orderNxshenpi"));
                if(r.progresstype == '3' && _.includes(r.dburl,"dingdmain/orderNxshenpi")){
                    if (undefined !=r.beizhu && '' != r.beizhu &&  null != r.beizhu  && r.beizhu.indexOf('外销订单-租赁订单') != -1){
                      this.order.nwsale = true;
                    }else {
                      this.order.nwsale = false;
                    }
                    this.order.orderid=r.ywid;
                    this.order.orderinstid=r.instid;
                    this.order.ordertaskid=r.id;
                    this.order.ordertaskstatus=r.status;
                    this.order.showOrderNxSp = true;
                    return;
                }
                console.log(r.dburl);
                if(r.progresstype == '3' && _.includes(r.dburl,"dingdmain/secondLevelOrderNxshenpi")){
                  if (undefined !=r.beizhu && '' != r.beizhu &&  null != r.beizhu  && r.beizhu.indexOf('外销订单-租赁订单') != -1){
                    this.order.nwsale = true;
                  }else {
                    this.order.nwsale = false;
                  }
                    this.order.orderid=r.ywid;
                    this.order.orderinstid=r.instid;
                    this.order.ordertaskid=r.id;
                    this.order.ordertaskstatus=r.status;
                    this.order.slShowOrderNxSp = true;
                    return;
                }
                if(r.progresstype == '3' && _.includes(r.dburl,"dingdmain/secondLevelFjNxshenpi")){
                  if (undefined !=r.beizhu && '' != r.beizhu &&  null != r.beizhu  && r.beizhu.indexOf('外销订单-租赁订单') != -1){
                    this.order.nwsale = true;
                  }else {
                    this.order.nwsale = false;
                  }
                    this.order.orderid=r.ywid;
                    this.order.orderinstid=r.instid;
                    this.order.ordertaskid=r.id;
                    this.order.ordertaskstatus=r.status;
                    this.order.slShowFjNxSp = true;
                    return;
                }
                if(r.progresstype == 'tcshenpi' && _.includes(r.dburl,"dingdmain/orderNxshenpi")){
                  if (undefined !=r.beizhu && '' != r.beizhu &&  null != r.beizhu  && r.beizhu.indexOf('外销订单-租赁订单') != -1){
                    this.order.nwsale = true;
                  }else {
                    this.order.nwsale = false;
                  }
                    this.order.orderid=r.ywid;
                    this.order.orderinstid=r.instid;
                    this.order.ordertaskid=r.id;
                    this.order.ordertaskstatus=r.status;
                    this.order.showOrderNxSp = true;
                    return;
                }

                /*if(r.status == '1'){
                    const {href} = this.$router.resolve({
                        path: r.dburl,
                        query: {taskid: r.id, ywid: r.ywid, instid: r.instid, taskstatus: r.status, link: 0}
                    })
                    window.open(href);
                }else{
                    const {href} = this.$router.resolve({
                        path: r.dburl,
                        query: {taskid: r.id, ywid: r.ywid, instid: r.instid, taskstatus: r.status, link: 0}
                    })
                    window.open(href);
                } */
                var chongXinTiJiao = 0;
                if(r.cjrcode == this._user.usercode){
                    chongXinTiJiao = 1;
                }
              if(r.progresstype == '3' && _.includes(r.dburl,"dingd/createNxOrder") &&
                  undefined !=r.beizhu && '' != r.beizhu &&  null != r.beizhu  && r.beizhu.indexOf('外销订单-租赁订单') != -1){
                r.dburl = "/dingd/createNwSaleOrder"
              }
                this.$router.push({
                    path: r.dburl,
                    query: {taskid: r.id, ywid: r.ywid, instid: r.instid, taskstatus: r.status,chongXinTiJiao: chongXinTiJiao}
                })

            },
            dbhandleFilter() {
                ss.taskservice.query(this.query).then(rd => {
                    this.query.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            changes(index, i) {
                this.indx = index;
                this.query.progresstype = this.activeCode
                this.query.status = i;
                this.search(status);
            },
            closeIt() {
                this.showOrhide = false;
                if (this.checked) {
                    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                } else {
                    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                }
            },
            nextStep(i) {
                if (this.status == 1) {
                    if (this.checked) {
                        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    } else {
                        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    }
                }
            }
        },
    }
</script>
<style scoped>
    .left {
        width: 96%;
        background-color: rgb(255, 255, 255);
        margin: 30px 30px 60px 30px;
        padding-bottom: 95px;
        border: 1px solid #E2E2E2;
        padding: 27px 40px 200px;
    }

    .title {
        margin-top: 20px;
    }

    .title .el-button {
        border-radius: 0;
        font-weight: 600;
        margin-bottom: 20px
    }

    .qita {
        background-color: #F0F5FB;
    }

    .qitaAc {
        background-color: #409EFF;
        color: #FFFFFF;
    }

    hr {
        margin-top: 10px;
        height: 1px;
        background-color: rgb(222, 226, 226);
        margin-right: 20px;
    }

    .hr {
        margin-top: 20px;
    }

    hr.border {
        border: none;
    }

    .shenpi {
        display: flex;
        flex-direction: column;
    }

    .title2 {
        height: 70px;
        line-height: 70px;
        font-size: 20px;
        font-weight: 800;
    }

    .s-row {
        padding: 0.1rem 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: 1px solid #ccc;
		color: #616467;
    }

    .type {
        flex-shrink: 0;
        width: 114px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 20px;
        margin-right: 10px;
    }

    .type-pt {
        background-color: #D3E4FF;
        color: #2A80E7;
        width: 1.2rem;
		padding: 0 0.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .type-gj {
        background-color: #FBDFC7;
        color: #FAAF6E;
    }

    .name {
        flex-shrink: 0;
        width: 110px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        background-color: #EEE;
        margin-right: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 10px;
    }

    .content {
        flex-grow: 1;
        display: flex;
    }

    .time {
        margin-left: 10px;
        color: #C0C0C0;
    }

    .submit {
        padding: 10px 30px;
        border-radius: 25px;
    }

    .submit-tj {
        border-color: #2A80E7;
        color: #2A80E7;
    }

    .submit-wc {
        border-color: #4BAE51;
        color: #4BAE51;
    }

    .buttonBox {
        border-bottom: 1px solid #d9dfe9;
        display: flex;
        height: 40px;
        align-items: center
    }

    .buttonBox .buttons {
        width: 77px;
        height: 100%;
        line-height: 40px;
        font-size: 0.16rem;
        color: #333;
        background: #f0f4fb;
        border: 1px solid #e1e8f4;
        margin-left: 20px;
        text-align: center;
        cursor: pointer;
    }

    .buttonBox .buttons.active {
        border: 1px solid #2785e7;
        background: #2785e7;
        color: #fff;
    }

    .buttonBox .buttons:first-child {
        margin-left: 0
    }
</style>

<style>
    .h-formbLine2 .el-form-item__label {
        width: 26% !important;
    }

    .h-formbLine2 .el-form-item__content {
        width: 74% !important;
    }
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
        z-index: 999999;
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;
        }

        .steps {
            position: absolute;
            z-index: 1;
        }

        .step1 {
            top: 0;
            left: 0;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.65rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
            z-index: 2;
        }
    }
	.overflowT{
		width: 5rem;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
    .content-xin{
        width:80%;
        margin: 0;
    }
</style>
